import React from 'react'
import { observer } from 'mobx-react'
import Checkbox from 'components/Checkbox'
import { Table, TableBody, TableHead, TableHeader } from 'components/Table'
import { match } from 'utils/pattern-match-util'
import ApplicantManagementPanelViewModel, {
  SelectionState,
} from '../ApplicantManagementPanel/ApplicantManagementPanelViewModel'
import { ColumnId } from './ApplicantManagementTableColumns'
import ApplicantManagementTableRow from '../ApplicantManagementTableRow'

interface ApplicantManagementTableProps {
  vm: ApplicantManagementPanelViewModel
}

export default observer(function ApplicantManagementTable({
  vm,
}: ApplicantManagementTableProps) {
  const columns = vm.columns
  return (
    <Table striped>
      <TableHead>
        {columns.map((column) =>
          column.id === ColumnId.Checkbox ? (
            <TableHeader
              key={column.id}
              className={column.styles}
              alignment={column.align}
            >
              <Checkbox
                onChange={() => vm.toggleAllApplicants()}
                checked={match(vm.selectionState, {
                  [SelectionState.AllSelected]: () => true,
                  [SelectionState.NoneSelected]: () => false,
                  [SelectionState.SomeSelected]: () =>
                    'indeterminate' as boolean | 'indeterminate',
                })}
                data-test={`applicant-manager-select-all-${vm.workspacePosting?.id}`}
              />
            </TableHeader>
          ) : (
            <TableHeader
              key={column.id}
              className={column.styles}
              alignment={column.align}
            >
              {column.header}
            </TableHeader>
          ),
        )}
      </TableHead>
      <TableBody>
        {vm.filteredApplicants.map((applicant) => (
          <ApplicantManagementTableRow
            vm={vm}
            applicant={applicant}
            key={applicant.userPublicId}
          />
        ))}
      </TableBody>
    </Table>
  )
})
